import { store } from "../redux/store/store";

export interface CrashContext {
  userId: number | null;
  accountId: number | null;
  currentBoard: number | null;
  appFeatureType: string | null;
  route: string;
  userAgent: string;
}

// Reads the Redux store singleton from outside React. Must never throw:
// it runs inside crash handlers, where a second failure would mask the first.
export const getCrashContext = (): Partial<CrashContext> => {
  try {
    const { userId, accountId, currentBoard, appFeatureType } = store.getState().monday;
    return {
      userId,
      accountId,
      currentBoard,
      appFeatureType,
      route: typeof window !== "undefined" ? window.location.pathname : "",
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    };
  } catch {
    return {};
  }
};
